import { timefitBackend } from '../../../Shared/Services/TimefitBackend';
import { keys } from '../../../Shared/Services/Query/Keys.ts';
import { useRecord } from '../../../Shared/Hooks/useRecord/useRecord.ts';

export function usePost(key: string) {
  const queryFn = () => timefitBackend.getPost(key);

  return useRecord(keys.posts.one(key), queryFn);
}
